import gql from 'graphql-tag'
import { DataProxy } from '~/node_modules/apollo-cache/src/types/DataProxy'
import { GQLHeaderArg } from '~/graphql/gqlLocal/localHeader.type'
import { GQLLocalHeader } from '~/graphql/__generated__/interfacesLocal'

const TYPE_NAME = 'Header'

export const initialState = {
  header: {
    __typename: TYPE_NAME,
    menuIsVisible: false,
    searchIsVisible: true,
    searchIsVisibleMobileOverlay: false,
    menuDesktopHiddenList: false,
  },
}

export const GET_LOCAL_HEADER = gql`
  {
    header @client {
      menuIsVisible
      searchIsVisible
      searchIsVisibleMobileOverlay
    }
  }
`

export const GET_LOCAL_MENU_VISIBILITY = gql`
  {
    header @client {
      menuIsVisible
      menuDesktopHiddenList
    }
  }
`

export const SET_HEADER_VISIBILITY = gql`
  mutation(
    $isMenuVisible: Boolean
    $isSearchVisible: Boolean
    $isSearchVisibleMobileOverlay: Boolean
    $menuDesktopHiddenList: Boolean
  ) {
    setHeaderVisiblity(
      isMenuVisible: $isMenuVisible
      isSearchVisible: $isSearchVisible
      isSearchVisibleMobileOverlay: $isSearchVisibleMobileOverlay
      menuDesktopHiddenList: $menuDesktopHiddenList
    ) @client
  }
`

export const mutationHeader = {
  setHeaderVisiblity: (
    _: {},
    args: GQLHeaderArg,
    { cache }: { cache: DataProxy }
  ) => {
    const currentHeaderData: {
      header: GQLLocalHeader
    } | null = cache.readQuery({
      query: GET_LOCAL_HEADER,
    })
    cache.writeData({
      data: {
        header: {
          ...currentHeaderData!.header,
          ...(args.isMenuVisible !== undefined
            ? { menuIsVisible: args.isMenuVisible }
            : {}),
          ...(args.isSearchVisible !== undefined
            ? { searchIsVisible: args.isSearchVisible }
            : {}),
          ...(args.isSearchVisibleMobileOverlay !== undefined
            ? {
                searchIsVisibleMobileOverlay: args.isSearchVisibleMobileOverlay,
              }
            : {}),
          ...(args.menuDesktopHiddenList !== undefined
            ? { menuDesktopHiddenList: args.menuDesktopHiddenList }
            : {}),
        },
      },
    })
  },
}
